import React, { ReactNode } from "react";
import { useState } from "@vrf/fr-vrf-core-react";
import {
  UserRoleMaintenancePageContext,
  UserRoleMaintenancePageInitialState,
} from ".";

export const UserRoleMaintenancePageStateProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [pageState, setPageState] = useState(
    UserRoleMaintenancePageInitialState,
  );
  const context = {
    pageState: pageState,
    setPageState: setPageState,
  };
  return (
    <UserRoleMaintenancePageContext.Provider value={context}>
      {children}
    </UserRoleMaintenancePageContext.Provider>
  );
};
